import { storageService } from '../../../../../../application/StorageService';
import { StorageKeys } from '../../../../../../constants/StorageKeys';
import { MapsApplicationTypes } from '../../../../../../interfaces/MapsApplication';

import { useQuery, useQueryClient } from '@tanstack/react-query';

type UseSessionLoginCodeResponseProps = {
  mapsApplication?: MapsApplicationTypes;
  isLoading: boolean;
  updateMapsApplication: (newValue: MapsApplicationTypes) => void;
};

export const useFetchMapsApplication = (): UseSessionLoginCodeResponseProps => {
  const queryClient = useQueryClient();

  const updateMapsApplication = (newValue: MapsApplicationTypes): void => {
    storageService.setItem({ key: StorageKeys.DRIVERS_MAPS_APPLICATION, item: newValue });
    queryClient.invalidateQueries([`maps_application`]); // Invalidate the query to trigger a re-fetch
  };
  const { data, isLoading } = useQuery([`maps_application`], () =>
    storageService.getItem({ key: StorageKeys.DRIVERS_MAPS_APPLICATION })
  );

  return {
    mapsApplication: data ? (data as MapsApplicationTypes) : undefined,
    isLoading,
    updateMapsApplication,
  };
};
